import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import QuizImg from '../../images/quiz.png'

function Quizzes() {
  return (
    <section id="quizzes">
      <Container>
        <Row className=" justify-content-center">
          <Col md={12} className="text-center">
            <h1>Unsure If You Need Help?</h1>
            <p>
              Select one of the quizzes below to complete a quick
              self-assessment.
            </p>
          </Col>
        </Row>
        <div className="card-container">
          <div className="card-wrapper">
            <img src={QuizImg} alt="" className="img-fluid quiz-img" />
            <h1>Alcohol Addiction Quiz</h1>
            <button className="get-started-btn btn">GET STARTED</button>
          </div>
          <div className="card-wrapper">
            <img src={QuizImg} alt="" className="img-fluid quiz-img" />
            <h1>Alcohol Addiction Quiz</h1>
            <button className="get-started-btn btn">GET STARTED</button>
          </div>
          <div className="card-wrapper">
            <img src={QuizImg} alt="" className="img-fluid quiz-img" />
            <h1>Alcohol Addiction Quiz</h1>
            <button className="get-started-btn btn">GET STARTED</button>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Quizzes
